import React, { useEffect, useState } from 'react'
import { Alert, Button, Col, Container, Form, Modal, Row } from 'react-bootstrap'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { NumericFormat } from 'react-number-format'
import { FontAwesomeIcon, } from '@fortawesome/react-fontawesome'
import { faPlusCircle, faSave, faSpinner, faTrash, fas } from '@fortawesome/free-solid-svg-icons'
import { float2moeda, moeda2float } from '../../../../utils/Funcoes'
import ModalSimNao from '../../../../components/ModalSimNao'
import { ServicosService } from '../../../../services/api/Servicos/ServicosService'


const ModalComissoes = ({ show, handleClose, profissionalSel, idServico, servico, fetchConv, setProfModalAdd }) => {

    const profissionaisObj = z.object({
        profissionaisId: z.coerce.string(),
        idServicoProfissionais: z.coerce.string(),
        nome: z.coerce.string(),
        possuiComissao: z.coerce.string(),
        tipoComissao: z.coerce.string(),
        valorComissao: z.coerce.string(),
        valor: z.coerce.string(),
        status: z.coerce.string(),
        valorConv: z.coerce.string(),
        valorCalcComissao: z.coerce.string(),
    })


    const scheme = z.object({
        servicosId: z.coerce.string(),
        profissionais: z.array(profissionaisObj)
    });


    const [formComissao, setFormComissao] = useState(null)
    const [disabled, setDisabled] = useState(false)
    const [idProfProcExcluidos, setIdProfProcExcluidos] = useState([])
    const [alertResult, setAlertResult] = useState({
        show: false,
        variant: '',
        msg: ''
    })
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [deleteSelected, setDeleteSelected] = useState(null)


    const { register, handleSubmit, watch, setValue, formState: { errors }, control } = useForm({
        mode: 'Blur',
        resolver: zodResolver(scheme),
        values: formComissao
    })


    const { fields: procProfissionaisFields, append, remove, update } = useFieldArray({ control, name: 'profissionais' })



    const ProcProfAdapter = (itens) => {
        let results = []
        itens?.map((item) => {

            let valorR = servico?.valor
            let valorComissaoC = calculaComissao(valorR, item.tipoComissao, item.valorComissao)
            results.push({
                ...item,
                idServicoProfissionais: item?.id,
                valorCalcComissao: 'Valor da comissão: R$ ' + float2moeda(valorComissaoC)
            })
        })
        return results;
    }

    useEffect(() => {

        const fetchProfComissaos = async () => {
            const data = await ServicosService.getProfissionaisVinculados(idServico, null, {
                profissionaisId: profissionalSel.id
            })
            if (data.success) {
                if (data.data.length > 0) {
                    setValue('profissionais', ProcProfAdapter(data.data))
                } else {
                    console.log(procProfissionaisFields)
                    if (procProfissionaisFields.length == 0) {
                      setValue('profissionais',[{

            profissionaisId: profissionalSel?.id,
            idServicoProfissionais: null,
            nome: '',
            conveniosId: '',
            conveniosNome: '',
            possuiComissao: 0,
            tipoComissao: '',
            valorComissao: null,
            valor: null,
            status: 1,
            valorConv: null,
            valorCalcComissao: null,
        }])
                    }
                }
            }
        }



        fetchProfComissaos()
        setValue('servicosId', idServico)
        setDisabled(false)
        setAlertResult({
            show: false,
            variant: '',
            msg: ''
        })
        setIdProfProcExcluidos([])

    }, [profissionalSel])



    const calculaComissao = (valorProc, tipoComissao, valorTipoComissao) => {

        // console.log(valorProc)
        // console.log(tipoComissao)
        //  console.log(valorTipoComissao)
        let result = '';
        switch (parseInt(tipoComissao)) {
            case 1: let percentual = valorTipoComissao / 100
                //     console.log(percentual)
                result = (valorProc * percentual).toFixed(2)
                break;
            case 2: result = valorTipoComissao
                break;

        }
        return result;
    }


    const handleChangeComissao = (e, index) => {
        let name = e.target.name.split('.')
        let value = e.target.value
        let FieldsSel = procProfissionaisFields[index]
        let result = '';
        console.log(moeda2float(servico?.valor))

        let valorConvenio = moeda2float(servico?.valor)

        setValue(`${e.target.name}`, value)
        switch (name[2]) {
            case 'possuiComissao':
                if (value == 0) {
                    setValue(`profissionais.${index}.tipoComissao`, "")
                    setValue(`profissionais.${index}.valorComissao`, "")
                    result = ''
                }
                break;
            case 'conveniosId':
                if (FieldsSel.possuiComissao == 1) {
                    result = calculaComissao(valorConvenio, FieldsSel.tipoComissao, FieldsSel.valorComissao)

                }
                break
            case 'tipoComissao':
                if (FieldsSel.possuiComissao == 1) {
                    result = calculaComissao(valorConvenio, value, FieldsSel.valorComissao)
                }
                break;
            case 'valorComissao':
                if (FieldsSel.possuiComissao == 1) {
                    result = calculaComissao(valorConvenio, FieldsSel.tipoComissao, value)

                }
                break;
        }
        result = (result != '') ? 'Valor da comissão: R$ ' + float2moeda(result) : ''
        setValue(`profissionais.${index}.valorCalcComissao`, result)


        update(index, {
            ...FieldsSel,
            [name[2]]: (value),
            valorCalcComissao: result
        })
    }
    //console.log(listConvenios)
    // console.log(procProfissionaisFields)



    const handleDeleteComissao = (index) => {
        setShowConfirmDelete(true)
        setDeleteSelected(index)

    }

    const handleConfirmDelete = () => {
        let procComissao = procProfissionaisFields[deleteSelected]
        if (procComissao.idServicoProfissionais != null) {
            idProfProcExcluidos.push(procComissao.idServicoProfissionais)
            setIdProfProcExcluidos(idProfProcExcluidos)
        }
        setShowConfirmDelete(false)
        remove(deleteSelected)
        setDeleteSelected(null)
    }

    const handleAdicionarComissao = () => {
        append({

            profissionaisId: profissionalSel?.id,
            idServicoProfissionais: null,
            nome: '',
            conveniosId: '',
            conveniosNome: '',
            possuiComissao: 0,
            tipoComissao: '',
            valorComissao: null,
            valor: null,
            status: 1,
            valorConv: null,
            valorCalcComissao: null,
        }
        )
    }
    const onSubmit = async (data) => {
        let dataProf = [];

        setDisabled(true)
        data?.profissionais?.map((item) => {
            dataProf.push({
                id: item.profissionaisId,
                possuiComissao: item.possuiComissao,
                tipoComissao: item.tipoComissao,
                valorComissao: item.valorComissao
            })
        })
        let DataForm = { profissionais: dataProf }
        DataForm.profissionaisExcluidosIds = idProfProcExcluidos

        const dataApi = await ServicosService.vincularProfissionais(data.servicosId, DataForm);
        if (dataApi.success) {

            setAlertResult({
                show: true,
                msg: 'Salvo com sucesso!',
                variant: 'success'
            })
            setProfModalAdd(null)
            setTimeout(() => {
                handleClose()
            }, 3000)

        } else {
            
            setAlertResult({
                show: false,
                msg: dataApi.msg,
                variant: 'danger'
            })
            setDisabled(false)
        }
        fetchConv()

    }

    return (
        <>
            <Modal show={(show && !showConfirmDelete) ? true : false} onHide={() => handleClose()} size='lg' fullscreen={false}>
                <Modal.Body style={{ fontSize: '14px' }} id="bodyModalComissao">
                    <h3><span className='text-success'> Comissões</span>  | {profissionalSel?.nome}</h3>
                    <Row>
                        <Col>  <label>Serviço:</label> {servico?.nome}</Col>
                        <Col>  <label>Valor:</label> R$ {servico?.valor}</Col>
                    </Row>
                    <br></br>

                    <Container fluid={true}>
                        <Row style={{ marginTop: '15px;', paddingBottom: '5px', borderBottom: '1px solid #dbdbdb', marginBottom: '15px', background: 'rgb(221, 221, 221)' }} className='d-none d-sm-flex'>


                            <Form.Group as={Col} controlId="" xs={12} md={4} className="text-left">
                                <Form.Label >Possui Comissão?</Form.Label>
                            </Form.Group>
                            <Form.Group as={Col} controlId="" xs={12} md={4} className="text-left">
                                <Form.Label >Tipo de Comissão</Form.Label>
                            </Form.Group>
                            <Form.Group as={Col} controlId="" xs={12} md={4} className="text-left">
                                <Form.Label >Valor de Comissão</Form.Label>
                            </Form.Group>


                            {/*} <Form.Group as={Col} controlId="" xs={12} md={1} className="text-left">
                                <Form.Label ></Form.Label>
                            </Form.Group>*/}

                        </Row>
                        {procProfissionaisFields?.map((campo, index) => (
                            <>


                                <Row
                                    style={{ marginBottom: '10px', borderBottom: '1px solid #dbdbdb' }}>

                                    <Form.Group as={Col} controlId="" xs={12} md={4} sm={2} className='reset-padding-xs'>
                                        <Form.Label className='d-md-none d-flex'>Possui Comissao?</Form.Label>
                                        <Controller
                                            render={({ field: { onChange, ...rest } }) => <select  {...rest}
                                                onChange={(e) => handleChangeComissao(e, index)}

                                                className="form-select">
                                                <option value="0">Não</option>
                                                <option value="1">Sim</option>
                                            </select>
                                            }
                                            name={`profissionais.${index}.possuiComissao`}
                                            control={control}
                                        />
                                    </Form.Group>

                                    <Form.Group as={Col} controlId="" xs={12} md={4} sm={2} className='reset-padding-xs'>
                                        <Form.Label className='d-md-none d-flex'>Tipo de Comissao? </Form.Label>
                                        <Controller
                                            render={({ field: { onChange, ...rest } }) => <select {...rest}
                                                onChange={(e) => handleChangeComissao(e, index)}
                                                className="form-select" disabled={campo.possuiComissao == 0}
                                            >
                                                <option value=""></option>
                                                <option value="1">Percentual  (%)</option>
                                                <option value="2">Valor fixo (R$)</option>
                                            </select>}
                                            name={`profissionais.${index}.tipoComissao`}
                                            control={control}
                                            defaultValue={campo.possuiComissao}
                                        />
                                    </Form.Group>



                                    <Form.Group as={Col} sm={4} md={4} className='reset-padding-xs'>
                                        <Form.Label className='d-sm-none d-flex'>Valor</Form.Label>
                                        <Controller
                                            name={`profissionais.${index}.valorComissao`}
                                            control={control}
                                            render={({ field: { ref, onChange, ...rest } }) => (
                                                <NumericFormat
                                                    disabled={campo.possuiComissao == 0}
                                                    className="form-control"
                                                    decimalSeparator=","
                                                    prefix=""
                                                    decimalScale={2}
                                                    getInputRef={ref}
                                                    {...rest}
                                                    onChange={(e) => handleChangeComissao(e, index)}
                                                />
                                            )}
                                        />
                                        <div className='text-left'> <label>{campo.valorCalcComissao}</label></div>

                                    </Form.Group>




                                    {/*}  <Form.Group as={Col} sm={4} md={1} className='text-right' >
                                        <Button variant='danger' size='sm' title='Remover convênio' onClick={() => handleDeleteComissao(index)}><FontAwesomeIcon icon={faTrash} /></Button>
                                    </Form.Group>*/}
                                </Row>

                            </>
                        ))}
                        <Alert show={(alertResult?.show)} variant={alertResult?.variant} className='text-center'>
                            {alertResult?.msg}
                        </Alert>
                        <div className='text-center'>
                            <Button variant='danger' size='sm' title='Remover convênio' onClick={() => handleClose()} className='mr-15'>Cancelar</Button>

                            <Button variant="primary" disabled={disabled} size="sm" onClick={() => handleSubmit(onSubmit)()}>
                                {(disabled) ? <>
                                    <FontAwesomeIcon icon={faSpinner} spin /> Salvando...
                                </> : (<> <FontAwesomeIcon icon={faSave} /> Salvar</>)}</Button>
                        </div>


                    </Container>
                </Modal.Body>


            </Modal>
            <ModalSimNao show={showConfirmDelete} handleClose={() => setShowConfirmDelete(false)} handleConfirm={() => handleConfirmDelete()}>
                Tem certeza que seja excluir este comissão?
            </ModalSimNao>
        </>
    )


}




export default ModalComissoes